import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useWatch } from 'react-hook-form';

import { usePreAuthFinePrint } from 'reservations/account/providers/ConfigProvider';
import { BaseDrawer } from 'reservations/base/components/BaseDrawer';
import { ModalType, useModal } from 'reservations/base/providers/ModalProvider';
import {
  CHOOSE_HOW_TO_PAY_SUBHEADER,
  SAVE_YOUR_CARD_HEADER
} from 'reservations/checklessPayments/constants';
import { getReadableCardType } from 'reservations/payments/helpers/getReadableCardType';

const ReviewUnsavedCardModal = () => {
  const [editCard, setEditCard] = useState(false);
  const { open } = useModal();
  const [cardDetails] = useWatch({ name: ['cardDetails'] });
  const { brand: cardType, last4: cardLast4 } = cardDetails;
  const footer = usePreAuthFinePrint();

  return (
    <BaseDrawer
      header={SAVE_YOUR_CARD_HEADER}
      subheader={CHOOSE_HOW_TO_PAY_SUBHEADER}
      footer={footer}
      primaryButton={{
        label: 'NEXT',
        onClick: () =>
          open(
            editCard ? ModalType.ChecklessEditCard : ModalType.ChecklessAddTip
          )
      }}
    >
      <FormControl>
        <RadioGroup>
          <FormControlLabel
            sx={{ width: '100%' }}
            value="existing"
            checked={!editCard}
            onChange={() => setEditCard(false)}
            control={<Radio />}
            label={
              <Box display="flex" flexDirection="row" alignItems="center">
                <Typography>
                  {getReadableCardType(cardType)} {cardLast4}
                </Typography>
              </Box>
            }
          />
          <FormControlLabel
            onChange={() => setEditCard(true)}
            value="new"
            checked={editCard}
            control={<Radio />}
            label={'Replace your card'}
          />
        </RadioGroup>
      </FormControl>
    </BaseDrawer>
  );
};

export default ReviewUnsavedCardModal;
